import React, { useRef, useEffect } from 'react';
import moment from 'moment';
import { useTranslations } from '@lang';
import { MetadataRow, DateContainer, OptionRow } from './EventMetadata.styles';
import { DetailTitle } from '../../styled';

export type EventMetadataProps = {
  eventDatetime: Date;
  eventOption: {
    name: string | null;
  };
};

export const EventMetadata: React.FC<EventMetadataProps> = ({ eventDatetime, eventOption }) => {
  const { t } = useTranslations();
  const eventDate = useRef(moment(eventDatetime).format('ddd, D MMM'));
  const eventTime = useRef(moment(eventDatetime).format('HH:MM'));

  useEffect(() => {
    eventDate.current = moment(eventDatetime).format('ddd, D MMM');
    eventTime.current = moment(eventDatetime).format('HH:MM');
  }, [eventDatetime]);

  return (
    <div>
      <MetadataRow>{eventOption && <OptionRow>{eventOption.name}</OptionRow>}</MetadataRow>
      <MetadataRow>
        <DateContainer>
          <DetailTitle showOnMobile>{t('common.date')}</DetailTitle>
          {eventDate.current}
        </DateContainer>
        <DateContainer>
          <DetailTitle showOnMobile>{t('common.time')}</DetailTitle>
          {eventTime.current}
        </DateContainer>
      </MetadataRow>
    </div>
  );
};
